/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The reducer for BreadCrumbs
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.2.0
 */

import produce from 'immer';

import { IBreadCrumbsActionTypes } from './breadCrumbsActions';
import { BREADCRUMBS_ADD, BREADCRUMBS_CLEAR } from './breadCrumbsConstants';
import { IBreadCrumb } from './breadCrumbsTypes';

export interface IBreadCrumbsState {
    data: IBreadCrumb[];
}

export const initialState: IBreadCrumbsState = {
    data: [],
};

const breadCrumbsReducer = (state = initialState, action: IBreadCrumbsActionTypes) =>
    produce(state, (draft) => {
        switch (action.type) {
            case BREADCRUMBS_ADD:
                draft.data = action.payload;
                break;
            case BREADCRUMBS_CLEAR:
                draft.data = [];
                break;
            default:
                break;
        }
    });

export default breadCrumbsReducer;
